export default "__VITE_PUBLIC_ASSET__4b04ac40__"